<template>
  <v-app-bar
      :color="isTopOfDocument ? 'navbar-background-top' : 'navbar-background'"
      :theme="$vuetify.theme.current.dark ? 'dark' : undefined"
      fixed
      :flat="isFlat"
      :height="height"
  >
    <v-app-bar-title>
      <v-btn :ripple="false" variant="plain" size="x-large" class="pl-0 py-0" :to="{name: RouteName.website.home.name}">
        <!--                    <v-img :src="ApplicationLogo" width="160"/>-->
        <application-name/>
      </v-btn>
    </v-app-bar-title>


    <DesktopNavigation v-if="$vuetify.display.mdAndUp"/>
    <MobileNavigation
        v-if="$vuetify.display.smAndDown"
        v-model="navigationStore.displayMainNavigation"
        @close="navigationStore.displayMainNavigation = false"
    />
    <v-btn
        v-if="$vuetify.display.smAndDown"
        icon="mdi-menu"
        class="pl-0"
        @click="navigationStore.displayMainNavigation = !navigationStore.displayMainNavigation"
    />
  </v-app-bar>
</template>

<script setup lang="ts">
import {RouteName} from "@/keys";
import DesktopNavigation from "@/components/navbar/desktop-navigation.vue";
import MobileNavigation from "@/components/navbar/mobile-navigation.vue";
import ApplicationName from "@/components/shared/application-title-logo.vue";
import {useAppbarConfig} from "@/composables/app-bar";
import {useNavigationStore} from "@/store/navigation";

const navigationStore = useNavigationStore();

const {height, isFlat, isTopOfDocument} = useAppbarConfig();
</script>
